import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";

angular.module("ticketco/common").directive("tcTooltip", function tooltips() {
  return {
    scope: {
      tooltipTitle: "@",
    },
    link: function (scope, elem, attrs) {
      let tippiInstance = tippy(elem[0], {
        content: scope.tooltipTitle,
        allowHTML: true,
      });

      elem.on("$destroy", function () {
        tippiInstance.destroy();
      });
    },
  };
});
